webpackJsonp([162114328119038],{

/***/ 544:
/***/ (function(module, exports, __webpack_require__) {

	// Generated by BUCKLESCRIPT VERSION 3.1.5, PLEASE EDIT WITH CARE
	'use strict';
	
	exports.__esModule = true;
	var Graphql = __webpack_require__(86);
	var ReasonReact = __webpack_require__(7);
	var CollectionPage = __webpack_require__(149);
	
	var component = ReasonReact.statelessComponent("Category");
	
	function make(data, pathContext, _) {
	  return (/* record */[
	    /* debugName */component[/* debugName */0],
	    /* reactClassInternal */component[/* reactClassInternal */1],
	    /* handedOffState */component[/* handedOffState */2],
	    /* willReceiveProps */component[/* willReceiveProps */3],
	    /* didMount */component[/* didMount */4],
	    /* didUpdate */component[/* didUpdate */5],
	    /* willUnmount */component[/* willUnmount */6],
	    /* willUpdate */component[/* willUpdate */7],
	    /* shouldUpdate */component[/* shouldUpdate */8],
	    /* render */function () {
	      return ReasonReact.element( /* None */0, /* None */0, CollectionPage.make(pathContext.category, Graphql.getNodes(data.packages), /* array */[]));
	    },
	    /* initialState */component[/* initialState */10],
	    /* retainedProps */component[/* retainedProps */11],
	    /* reducer */component[/* reducer */12],
	    /* subscriptions */component[/* subscriptions */13],
	    /* jsElementWrapped */component[/* jsElementWrapped */14]]
	  );
	}
	
	var $$default = ReasonReact.wrapReasonForJs(component, function (jsProps) {
	  return make(jsProps.data, jsProps.pathContext, /* array */[]);
	});
	
	var query = exports.query = "** extracted graphql fragment **";
	
	exports.component = component;
	exports.make = make;
	exports.$$default = $$default;
	exports.default = $$default;
	exports.__esModule = true;
	/* component Not a pure module */

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-category-js-34b2bae4633e303e8470.js